import { CommonService } from './../common/common.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private _commonService: CommonService,
    private _httpClient: HttpClient
  ) { }

  public getUsers(
    filter: string = '',
    page: number = 0,
    searchText: string = '',
    usersFilterProperty: string = '',
    usersFilterDirection: string = '',
    endpoint: string = 'user/getUsers') : Observable<any> {
    let apiUrl = `${this._commonService.getApiUrl()}/${endpoint}?page=${page}&quickSearch=${searchText}`;
    apiUrl = (filter) ? `${apiUrl}&filter=${filter}` : apiUrl;
    apiUrl = (usersFilterProperty) ? `${apiUrl}&filterHeader=${usersFilterProperty} ${usersFilterDirection}` : apiUrl;

    return this._httpClient.get(apiUrl);
  }
}
